<template>
  <b-nav-item-dropdown
    class="dropdown-cart mr-25"
    menu-class="dropdown-menu-media"
    right
  >
    <template #button-content>
      <feather-icon
        class="text-body"
        icon="ShoppingCartIcon"
        size="21"
        @click="cartRefresh()"
      />
    </template>

    <!-- Header -->
    <li class="dropdown-menu-header">
      <div class="dropdown-header d-flex">
        <h4 class="notification-title mb-0 mr-auto">
          Commande en cours
        </h4>
        <b-badge
          pill
          variant="light-primary"
        >

        </b-badge>
      </div>
    </li>

    <!-- Cart Items -->
    <vue-perfect-scrollbar
      v-if="this.items.length"
      class="scrollable-container media-list scroll-area"
      tagname="li"
    >
      <b-media
        v-for="item in this.items"
        :key="item.id"
      >
        <template #aside>
          <b-img
            :src="item.image"
            :alt="item.nom"
            rounded
            width="62px"
          />
        </template>
        <feather-icon
          icon="XIcon"
          class="cart-item-remove cursor-pointer"
          @click.stop="removeItemFromCart(item.id)"
        />
        <div class="media-heading">
          <h6 class="cart-item-title">
            <b-link class="text-body">
              {{ item.nom }}
            </b-link>
          </h6>
          <!-- <small class="cart-item-by">par {{ item.fournisseur}}</small> -->
          <small class="cart-item-by">Prix {{ parseFloat(item.prix).toFixed(2)}} {{ setting.devise }} HT</small>
          <small class="cart-item-by">Prix {{ parseFloat(item.prix).toFixed(2) + (parseFloat(item.prix).toFixed(2) * 0.2)}} {{ setting.devise }} TTC</small>
        </div>

        <div class="cart-item-qty ml-1">
          <b-form-spinbutton
            v-model="item.quantite"
            min="1"
            size="sm"
          />
        </div>

        <h5 class="cart-item-price">
          {{ item.quantite * item.prix }} {{ setting.devise }} HT
        </h5>
      </b-media>
    </vue-perfect-scrollbar>

    <!-- Cart Footer -->
    <li
      v-if="this.items.length"
      class="dropdown-menu-footer"
    >
      <div class="d-flex justify-content-between mb-1">
        <h6 class="font-weight-bolder mb-0">
          Total:
        </h6>
        <h6 class="text-primary font-weight-bolder mb-0">
          {{ totalAmount }} {{ setting.devise }}
        </h6>
      </div>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
        :to="{ name: 'apps-e-commerce-checkout' }"
      >
        Valider
      </b-button>
    </li>

    <p
      v-if="!this.items.length"
      class="m-0 p-1 text-center"
    >
      Commande vide
    </p>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BBadge, BMedia, BLink, BImg, BFormSpinbutton, BButton,
} from 'bootstrap-vue'
// import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BNavItemDropdown,
    BBadge,
    BMedia,
    BLink,
    BImg,
    BFormSpinbutton,
    // VuePerfectScrollbar,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      items: [],
      setting: JSON.parse(localStorage.setting),
      perfectScrollbarSettings: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },
    }
  },
  computed: {
    totalAmount() {
      // items = []
      let total = 0
      this.items.forEach(i => { total += i.prix * i.quantite})
      return parseFloat(total).toFixed(2)
    },
  },
  methods: {
    cartRefresh() {
      console.log('refresh', this.$invoice.products)
      this.items = this.$invoice.products
      console.log('items', this.items)
    },
    // fetchItems() {
    //   this.$store.dispatch('app-ecommerce/fetchCartProducts')
    //     .then(response => {
    //       this.items = items
    //     })
    // },
    // removeItemFromCart(productId) {
    //   this.$store.dispatch('app-ecommerce/removeProductFromCart', { productId })
    //     .then(() => {
    //       const itemIndex = this.items.findIndex(p => p.id === productId)
    //       this.items.splice(itemIndex, 1)

    //       // Update count in cart items state
    //       this.$store.commit('app-ecommerce/UPDATE_CART_ITEMS_COUNT', this.items.length)
    //     })
    // },
  },
}
</script>

<style lang="scss" scoped>
.dropdown-cart {
  .media {
    .media-aside {
      align-items: center;
    }
  }
}
</style>
